import React from "react";
import { List, Card, Descriptions } from "antd";
import { $t } from "~/i18n.js";
import { HelpBubble } from "~/components/help/helpBubble.jsx";
import { _parseDate } from "~/lib/localize.js";

export const MedicalHistory = ({ medicalHistory }) => {
  if (!medicalHistory || medicalHistory.length === 0) return null;

  return (
    <div style={{ marginTop: 24 }}>
      <p className="subtitle">
        {$t("Historie van medical")}
        <HelpBubble
          content={$t(
            "Door eisen in de wetgeving worden controles van de medicals voor 3 jaar opgeslagen"
          )}
        />
      </p>
      <List
        size="small"
        itemLayout="vertical"
        dataSource={medicalHistory}
        renderItem={(item) => (
          <List.Item>
            <Descriptions column={1} size="small">
              <Descriptions.Item label={$t("Datum controle")}>
                <span className="bold">{_parseDate(item.date_checked)}</span>
              </Descriptions.Item>
              <Descriptions.Item label={$t("Door")}>
                {item.checked_by}
              </Descriptions.Item>
              <Descriptions.Item label={$t("Geldigheid")}>
                {_parseDate(item.valid_from)} {$t("tot")}{" "}
                {_parseDate(item.valid_to)}
              </Descriptions.Item>
            </Descriptions>
          </List.Item>
        )}
      />
    </div>
  );
};
